import { getRenderStyleProperty } from '../../../../../../CanvasState/Helpers/Style/textBody';
import { getPrioritizedTextBody } from '../../../Utils/textBody';

const getVerticalAlign = shape => getRenderStyleProperty(shape, getPrioritizedTextBody(shape), ['verticalAlign']);

export default getVerticalAlign;
